import { ColorOptions } from "@/src/types";
import { MainInner, StyledMainSection } from "@/styles/global";
import { DisplayHeadingM, DisplayHeadingS, H2, H3 } from "@/styles/typography";
import styled from "styled-components";

type NewsletterProps = {
  $backgroundColor: ColorOptions;
  $backgroundType: "card" | "fill";
};

const Inner = styled(MainInner)`
  gap: 24px;

  border-radius: 12px;
  padding-block: 40px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    border-radius: 21px;
    display: grid;
    grid-template-columns: 2fr 1.5fr;
    gap: 72px;

    justify-content: space-between;
    align-items: center;
  }
`;

const TitleWrapper = styled.div``;

const Title = styled(DisplayHeadingS)`
  font-size: clamp(20px, 5vw, 40px);
`;

const SmallTitle = styled(H2)<{ $color: ColorOptions }>`
  color: ${({ $color, theme }) => theme.colors[$color]};
`;

const Section = styled(StyledMainSection)<NewsletterProps>`
  ${({ $backgroundType, theme, $backgroundColor }) =>
    $backgroundType === "fill" &&
    `
        background-color: ${theme.colors[$backgroundColor]};
        margin: 0;
        position: relative;
`}

  ${Inner} {
    background-color: ${({ $backgroundColor, theme }) =>
      theme.colors[$backgroundColor]};
    margin: ${({ $backgroundType }) =>
      $backgroundType === "fill" ? "0 auto" : "0 24px"};

    width: ${({ $backgroundType }) =>
      $backgroundType === "fill" ? "100%" : "calc(100% - 48px)"};

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      max-width: 1512px;
      margin: 0 auto;
    }
  }

  ${Title} {
    color: ${({ $backgroundColor, theme }) =>
      $backgroundColor === "black" || $backgroundColor === "brown"
        ? theme.colors.creme
        : $backgroundColor === "yellow"
          ? theme.colors.brown
          : theme.colors.black};
  }
`;

const S = { Section, Inner, Title, TitleWrapper, SmallTitle };

export default S;
